export default __webpack_public_path__ + "static/media/swipe-impact-desktop.ec9efb8d.png";